import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var SendIcon = function SendIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "SendIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1.134 2.773c-.525-1.05.59-2.164 1.64-1.639l11.55 5.773c.901.45.901 1.736 0 2.186l-11.55 5.773c-1.05.525-2.165-.589-1.64-1.64L3.75 8zm3.884 5.958-2.253 4.505L13.24 8 2.765 2.764 5.018 7.27h2.461a.731.731 0 1 1 0 1.462zM2.12 13.558",
      clipRule: "evenodd"
    })
  }));
};

export { SendIcon };
